module.exports = __webpack_public_path__ + "img/pm.95e49bbc.png";